import type { Route } from '@onhandtech/onhand-fe-shared/lib/contracts/config/routes'
import { getRouteByKey } from '@onhandtech/onhand-fe-shared/lib/router'
import type { RouteKey } from 'contracts/config/routes'

import { getConfig } from '../config/configuration'

export const getRoutePath = (key: RouteKey): string => {
  const { routes } = getConfig()
  return getRouteByKey<RouteKey, Route<RouteKey>>(key, routes)?.path ?? '/'
}
